export const PlacementOptions = {
  left: `
   top: 50% !important;
   transform: translateY(-50%) !important;
   right: calc(100% + 6px) !important;  `,
  leftTop: `
   top: 0 !important;
   right: calc(100% + 6px) !important;  `,
  leftBottom: `
  bottom: 0 !important;
  right: calc(100% + 6px) !important; `,
  right: `
   top: 50% !important;
   transform: translateY(-50%) !important;
   left: calc(100% + 6px) !important; `,
  rightTop: `
   top: 0 !important;
  left: calc(100% + 6px) !important; `,
  rightBottom: `
   bottom: 0 !important;
  left: calc(100% + 6px) !important;`,
  topRight: `
  bottom: calc(100% + 6px) !important;
  right: 0 !important; `,
  topLeft: `
   bottom: calc(100% + 6px) !important;
   left: 0 !important; `,
  top: `
   bottom: calc(100% + 6px) !important;
  left: 50% !important;
  transform: translateX(-50%) !important; `,
  bottom: `
  top: calc(100% + 6px) !important;
  left: 50% !important;
  transform: translateX(-50%) !important;`,
  bottomRight: `
   top: calc(100% + 6px) !important;
  right: 0 !important;`,
  bottomLeft: `
  top: calc(100% + 6px) !important;
  left: 0 !important;`,
};

export const ArrowPlacementOptions = {
  topLeft: `
    bottom: 2px !important;
    left: 24px !important;
    border-width: 8px 8.5px 0 8.5px !important;
    border-color: #292a2c transparent transparent transparent !important;
    `,
  topRight: `
    bottom: 2px !important;
    right: 6px !important;
    left: unset !important;
    border-width: 8px 8.5px 0 8.5px !important;
    border-color: #292a2c transparent transparent transparent !important;
    `,
  top: `
    left:50% !important;
    bottom: -5px !important;
    transform: translateX(-50%) !important;
    border-width: 8px 8.5px 0 8.5px !important;
    border-color: #292a2c transparent transparent transparent !important;
    `,
  bottom: `
    left: 50% !important;
    top: -5px !important;
    transform: translateX(-50%) !important;
    border-width: 0 8.5px 8px 8.5px !important;
    border-color: transparent transparent #292a2c transparent !important;
    `,
  bottomRight: `
    right: 6px !important;
    left: unset !important;
    top: 2px !important;
    border-width: 0 8.5px 8px 8.5px !important;
    border-color: transparent transparent #292a2c transparent !important;
    `,
  bottomLeft: `
    left: 25px !important;
    top: 2px !important;
    border-width: 0 8.5px 8px 8.5px !important;
    border-color: transparent transparent #292a2c transparent !important;
    `,
  right: `
    left: -5px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    border-width: 8.5px 11px 8.5px 0 !important;
    border-color: transparent #292a2c transparent transparent !important;
    `,
  rightTop: `
   left: -5px !important;
   top: 20px !important;
   bottom: unset !important;
   transform: translateY(-50%) !important;
   border-width: 8.5px 11px 8.5px 0 !important;
   border-color: transparent #292a2c transparent transparent !important;
    `,
  rightBottom: `
   left: -3px !important;
   bottom: 10px !important;
   top: unset !important;
   border-width: 8.5px 11px 8.5px 0 !important;
   border-color: transparent #292a2c transparent transparent !important;
     `,
  left: `
   right: -5px !important;
   top: 50% !important;
   bottom: unset !important;
   transform: translateY(-50%) !important;
   border-width: 8.5px 0 8.5px 12px !important;
   border-color: transparent transparent transparent #292a2c !important;
     `,
  leftTop: `
   right: -5px !important;
   top: 15px !important;
   transform: translateY(-50%) !important;
   border-width: 8.5px 0 8.5px 12px !important;
   border-color: transparent transparent transparent #292a2c !important;
        `,

  leftBottom: `
   right: -5px !important;
   bottom: 10px !important;
   top: unset !important;
   border-width: 8.5px 0 8.5px 12px !important;
   border-color: transparent transparent transparent #292a2c !important;
     `,
};
